import { Dialog, type DialogProps } from '@shared/components';
import { useState } from 'react';

import {
  AddItemSetQuestionConditionsProvider,
  useAddItemSetQuestionConditions,
} from '../../providers';
import { type ModalContentMapType } from '../../types';
import AddItemSetQuestionContent from '../add-item-set-question-content/add-item-set-question-content';
import { SelectTopicContent, type SelectTopicContentProps } from '../select-topic-content';

export interface AddItemSetQuestionConditionsModalProps extends DialogProps {
  chapterId: string;
  onClose: () => void;
  onSubmit?: () => void;
}

export default function AddItemSetQuestionConditionsModal(
  props: Readonly<AddItemSetQuestionConditionsModalProps>,
) {
  const { chapterId, onClose, onSubmit, open: isModalOpen } = props;
  const [modalContent, setModalContent] = useState<keyof ModalContentMapType>(
    'ADD_ITEM_SET_QUESTION_CONTENT',
  );

  const changeToAddItemSetQuestionContent = () => {
    setModalContent('ADD_ITEM_SET_QUESTION_CONTENT');
  };

  return (
    <Dialog open={isModalOpen}>
      <AddItemSetQuestionConditionsProvider chapterId={chapterId}>
        {modalContent === 'ADD_ITEM_SET_QUESTION_CONTENT' ? (
          <AddItemSetQuestionContent
            onClose={onClose}
            onSubmit={onSubmit}
            setModalContent={setModalContent}
          />
        ) : null}
        {modalContent === 'SELECT_TOPIC_CONTENT' ? (
          <SelectTopicContentWithContext
            onClose={onClose}
            onBack={changeToAddItemSetQuestionContent}
          />
        ) : null}
      </AddItemSetQuestionConditionsProvider>
    </Dialog>
  );
}

function SelectTopicContentWithContext(
  props: Readonly<Pick<SelectTopicContentProps, 'onClose' | 'onBack'>>,
) {
  const { onClose, onBack } = props;
  const { chapterData, levelItemsWithLevel, checkExistOnStructures } =
    useAddItemSetQuestionConditions();

  return (
    <SelectTopicContent
      mode='create'
      chapterData={chapterData}
      levelItemsWithLevel={levelItemsWithLevel}
      checkExistOnStructures={checkExistOnStructures}
      onClose={onClose}
      onBack={onBack}
    />
  );
}
